import React, { FC } from 'react';

import { observer } from 'mobx-react-lite';

import ImgAvatar1 from '@/shared/pictures/avatar1.png';
import { glueName } from '@/shared/utils/users';
import { numWord } from '@/shared/utils/numWord';
import { IUser } from '@/entities/user/types';


interface RatingItemProps {
  place: number,
  user:IUser
}

export const RatingItem:FC<RatingItemProps> = observer(({place,user}) => {

  return (
    <div className='rating-list_item'>
        <p className='rating-list_number'>{place}</p>
        <div className='rating-list_user'>
          <img className='rating-list_icon' src={user.photoUrl} alt="icon" />
          <p className='rating-list_name'>{glueName(user)}</p>
        </div>
        <p className='rating-list_pucks'>{user.score + ' ' + numWord(user.score, ['шайба','шайбы','шайб']) }</p>
    </div>
  );

});